/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccessToken } from '../models/AccessToken';
import type { EmailCaptchaPayload } from '../models/EmailCaptchaPayload';
import type { EmailOtpCodeFingerprintPayload } from '../models/EmailOtpCodeFingerprintPayload';
import type { EmailPayload } from '../models/EmailPayload';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UnverifiedUsersService {
    /**
     * Create Unverified User
     * Unverified user is someone who hasn't verified their email address yet.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createUnverifiedUserApiPublicUnverifiedCreatePost(
        requestBody: EmailCaptchaPayload,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/public/unverified/create',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                409: `Conflict`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Verify User
     * @param requestBody
     * @returns AccessToken Successful Response
     * @throws ApiError
     */
    public static verifyUserApiPublicUnverifiedVerifyPost(
        requestBody: EmailOtpCodeFingerprintPayload,
    ): CancelablePromise<AccessToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/public/unverified/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Resend Otp
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static resendOtpApiPublicUnverifiedResendOtpPost(
        requestBody: EmailPayload,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/public/unverified/resend-otp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `Validation Error`,
            },
        });
    }
}
